export default "__VITE_PUBLIC_ASSET__5c08d35c__"